export default __webpack_public_path__ + "static/relay-beda0f3c2c47cabcf75a0cbe0f8c9c01.jpg";